import { apiSlice } from "../../app/api/apiSlice";

export const athenaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    isPublishEnabled: builder.mutation({
      query: (credentials) => ({
        url: "/appointment/fetch",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    publishToAthena: builder.mutation({
      query: (credentials) => ({
        url: `/athena/publish`,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    uploadDocumentAthena: builder.mutation({
      query: (fileData) => ({
        url: `/athena/documents/clinicaldocuments`,
        method: "POST",
        body: fileData,
      }),
    }),
    fetchCancelReasons: builder.mutation({
      query: ({ practiceId }) => ({
        url: `/athena/appointment/cancelReasons?practiceId=${practiceId}`,
        method: "GET",
      }),
    }),
    fetchProviderTypes: builder.mutation({
      query: ({ practiceId }) => ({
        url: `/athena/provider/types?practiceId=${practiceId}`,
        method: "GET",
      }),
    }),
    fetchProviderSpecialities: builder.mutation({
      query: ({ practiceId }) => ({
        url: `/athena/provider/specialities?practiceId=${practiceId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useIsPublishEnabledMutation,
  usePublishToAthenaMutation,
  useUploadDocumentAthenaMutation,
  useFetchCancelReasonsMutation,
  useFetchProviderTypesMutation,
  useFetchProviderSpecialitiesMutation,
} = athenaApiSlice;
